import {FilterKey, filtersConfig} from './constants'

/**
 * Get object of filter keys and enabled/disabled boolean, for tracking
 */
export const getSelectedFiltersMap = (filters: FilterKey[]) =>
  Object.fromEntries(
    filtersConfig.map(({id}) => [id, filters.includes(id)])
  ) as Record<FilterKey, boolean>
